import dayjs from 'dayjs';

export const POS_HOLD_MIN = 0;
export const POS_HOLD_MAX = 10080;

export const POS_HOLD_TITLE = 'Hold catering orders from POS';
export const POS_HOLD_LABEL = 'Hold until (minutes before scheduled time)';
export const POS_HOLD_HELP = 'The order is sent to the POS this many minutes before the scheduled time. 0 sends on accept.';

export function posHoldError(value) {
  if (value === null || value === undefined || value === '') {
    return 'Enter a whole number of minutes.';
  }
  const minutes = typeof value === 'string' ? Number(value.trim()) : value;
  if (typeof minutes !== 'number' || !Number.isInteger(minutes)) {
    return 'Enter a whole number of minutes.';
  }
  if (minutes < POS_HOLD_MIN || minutes > POS_HOLD_MAX) {
    return `Enter a whole number from ${POS_HOLD_MIN} to ${POS_HOLD_MAX}.`;
  }
  return null;
}

export function formatPosTime(value, now = dayjs()) {
  const time = dayjs(value);
  return time.isSame(now, 'day') ? time.format('h:mm A') : time.format('MMM D, h:mm A');
}

/** Compact label for the order list (avoids overlapping adjacent columns). */
export function queuedPosListTag(when) {
  return when ? `POS ~${when}` : 'Queued for POS';
}

export function queuedPosListTooltip(when) {
  return when ? `Sends to POS around ${when}` : 'Queued for POS';
}

export function queuedPosDetailMessage(when) {
  return when ? `Queued for POS. Sends to POS around ${when}.` : 'Queued for POS.';
}
